import { type ReactNode, useState } from 'react';
import { ArrowLeftRight } from 'lucide-react';
import type { Approacher } from '../types';
import { SwapIgModal } from './swap-ig-modal';

type Props = {
  approacher: Approacher;
  onUpdated?: (() => void) | undefined;
};

const BTN =
  'inline-flex items-center gap-xs rounded-md border border-white/[0.06] px-sm py-1 text-[11px] text-text-secondary transition-colors hover:border-brand-red/40 hover:text-brand-red disabled:cursor-not-allowed disabled:opacity-40';

function titleFor(canSwap: boolean): string {
  return canSwap
    ? 'Intercambia el Instagram principal con el personal'
    : 'Define un Instagram personal para poder intercambiar';
}

export function SwapIgTrigger({ approacher, onUpdated }: Props): ReactNode {
  const [open, setOpen] = useState(false);
  const canSwap = !!approacher.personal_ig_username;
  return (
    <>
      <div className="flex items-center justify-end px-1">
        <button
          onClick={() => setOpen(true)}
          disabled={!canSwap}
          className={BTN}
          title={titleFor(canSwap)}
        >
          <ArrowLeftRight size={12} />
          Intercambiar Instagram
        </button>
      </div>
      <SwapIgModal
        open={open}
        onClose={() => setOpen(false)}
        approacher={approacher}
        onUpdated={onUpdated}
      />
    </>
  );
}
